<template>
    <el-container>
        <el-aside class="app_aside">
            <div class="app_logo">
                <img src="../assets/logo.png" alt="">
            </div>
            <MyAside :asideId="app_asideId"></MyAside>
        </el-aside>
        <el-container>
            <el-header>
                <MyHeader></MyHeader>
            </el-header>
            <div class="app_con">

                <div class="app_Rig">
                    <div class="app_TNav">
                        <div class="app_TList">
                          <div class="app_TItem"
                               v-for="(todo, index) in todos"
                               :class="{ app_TAct: activeTabIndex === index }"
                               @click="switchTab(index)">
                            {{todo.title}} <i class="el-icon-close" @click.stop="removeTodo(index)" v-if="index>0"></i>
                          </div>
                        </div>
                    </div>
                    <el-main>
                        <div class="taskTop">
                            <div class="taskFrom">
                              <el-form ref="taskFrom" :model="taskFrom" label-width="80px">
                                <el-form-item label="关键词:" class="taskItem">
                                  <el-input v-model="taskFrom.name"
                                            placeholder="任务编号/需求描述"></el-input>
                                </el-form-item>
                                <el-form-item label="状态:" class="taskItem">
                                  <el-select v-model="taskFrom.state" placeholder="请选择">
                                    <el-option label="全部" value="0"></el-option>
                                    <el-option label="通过" value="1"></el-option>
                                    <el-option label="未通过" value="2"></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="类型:" class="taskItem">
                                  <el-select v-model="taskFrom.type" placeholder="请选择">
                                    <el-option label="短视频" value="1"></el-option>
                                    <el-option label="图片处理" value="2"></el-option>
                                    <el-option label="PPT" value="3"></el-option>
                                    <el-option label="CAD效果" value="4"></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="任务佣金:" class="taskItem hallJg">
                                  <el-input v-model="taskFrom.minPrice" placeholder="最低价">
                                    <template slot="prepend">￥</template></el-input>
                                  <i class="el-icon-minus"></i>
                                  <el-input v-model="taskFrom.maxPrice" placeholder="最高价">
                                    <template slot="prepend">￥</template></el-input>
                                </el-form-item>
                                <el-form-item label="发布时间:" class="taskItem taskItem_T">
                                  <el-date-picker v-model="taskFrom.timec" type="daterange" range-separator="至"
                                                  start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="接单时间:" class="taskItem taskItem_T">
                                  <el-date-picker v-model="taskFrom.timeb" type="daterange" range-separator="至"
                                                  start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="交付时间:" class="taskItem taskItem_T">
                                  <el-date-picker v-model="taskFrom.timea" type="daterange" range-separator="至"
                                                  start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="验收时间:" class="taskItem taskItem_T">
                                  <el-date-picker v-model="taskFrom.timee" type="daterange" range-separator="至"
                                                  start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                </el-form-item>
                                <div class="taskFBon">
                                  <el-button icon="el-icon-refresh" @click="taskFrom={};list()">重置</el-button> <el-button
                                    icon="el-icon-search" @click="list">搜索</el-button>
                                </div>
                              </el-form>
                            </div>
                        </div>
                        <div class="taskCon">
                            <div class="taskCTit">
                                <p>完结订单</p>
                                <div class="taskCRig" @click="fetchTableData()">
                                    <i class="el-icon-refresh-left"></i>
                                </div>
                            </div>
                            <div class="taskCTable">
                              <el-table :data="tableData" border>
                                <el-table-column fixed prop="bh" label="任务编号" width="180">
                                </el-table-column>
                                <el-table-column prop="stateb" label="状态" width="120">
                                </el-table-column>
                                <el-table-column prop="ystime" label="验收时间" width="200">
                                </el-table-column>
                                <el-table-column prop="ysjg" label="验收结果" width="120">
                                </el-table-column>
                                <el-table-column prop="ys" label="验收说明" width="220  ">
                                </el-table-column>
                                <el-table-column prop="thumb" label="评价" width="220  ">
                                </el-table-column>
                                <el-table-column prop="type" label="类型" width="200">
                                </el-table-column>
                                <el-table-column prop="xcon" label="需求描述" min-width="250">
                                </el-table-column>
                                <el-table-column prop="yjprice" sortable label="任务佣金" width="150">
                                </el-table-column>
                                <el-table-column prop="bzprice" sortable label="保证金" width="150">
                                </el-table-column>
                                <el-table-column prop="sjprice" sortable label="手续费" width="150">
                                </el-table-column>
                                <el-table-column prop="jgtime" sortable label="交稿时限" width="220">
                                </el-table-column>
                                <el-table-column prop="xma" label="联系人" width="120">
                                  <template slot-scope="scope">
                                    <p v-if="scope.row.hm">{{scope.row.hm}}</p>
                                    <p v-else>{{scope.row.xm}}</p>
                                  </template>
                                </el-table-column>
<!--                                <el-table-column prop="tel" label="联系人电话" width="150">-->
<!--                                </el-table-column>-->
<!--                                <el-table-column  label="微信二维码" width="150">-->
<!--                                  <template slot-scope="scope">-->
<!--                                    <img :src="scope.row.wx" @click="handleImageClick(scope.row.wx)" style="height: 25px; cursor: pointer;object-fit: cover;" />-->
<!--                                  </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column prop="jdr" label="接单人昵称" width="150">-->
<!--                                </el-table-column>-->
<!--                                <el-table-column prop="jdrtel" label="接单人电话" width="150">-->
<!--                                </el-table-column>-->
<!--                                <el-table-column  label="接单人微信二维码" width="180">-->
<!--                                  <template slot-scope="scope">-->
<!--                                    <img :src="scope.row.jdrwx" @click="handleImageClick(scope.row.wx)" style="height: 25px; cursor: pointer;object-fit: cover;" />-->
<!--                                  </template>-->
<!--                                </el-table-column>-->
                                <el-table-column fixed="right" label="操作" width="120">
                                  <template slot-scope="scope">
                                    <el-button class="app_mlTableCk" type="text" size="small"
                                               @click="detailsShowa(scope.row.id)">查看</el-button>
                                    <el-button class="app_mlTableCk" type="text" size="small" v-if="userpath==1&&scope.row.thumb==''"
                                                 @click.native="checkordera(scope.row.id)">评价</el-button>

                                  </template>
                                </el-table-column>
                              </el-table>
                              <div class="app_page" v-if="tableData.length>0">
                                <el-pagination
                                    @size-change="sizechange"
                                    @current-change="handleCurrentChange"
                                    layout="sizes, prev, pager, next"
                                    :page-sizes="[10,50,80,100]" :page-size="10" :total="pagesize" :current-page="onpage">
                                </el-pagination>
                              </div>

                              <el-empty description="暂无数据" v-else></el-empty>
                            </div>
                        </div>
                      <el-dialog title="任务详情" class="TaskDetails" :visible.sync="detailsShow">
                        <div class="TaskDTbox" v-html="listcon.html"  @click="handleClick" ref="htmlContainer">
                        </div>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="detailsShow = false" class="Password_hide">关闭</el-button>
                        </div>
                      </el-dialog>
                      <el-dialog title="验收订单" class="TaskDetails release" :visible.sync="editShowa">
                        <el-form ref="editForm" :model="editForma" label-width="100px">
                          <div class="editFbox">
                            <div class="orderXTit">任务信息</div>
                            <div class="orderFrom">
                              <el-form-item label="任务编号:" class="editFItem">
                                <div class="editFbh">{{editForma.bh}}</div>
                              </el-form-item>
                              <el-form-item label=" 类型:" class="editFItem">
                                {{editForma.xtype}}
                              </el-form-item>
                            </div>
                          </div>
                          <div class="orderCBox">
                            <div class="orderXTit">验收信息</div>
                            <div class="orderFrom">
                              <el-form-item label="验收图片:"  class="editFItem">
                                <div v-for="(item, index) in editForma.filea" :key="index" class="avatar-wrapper">
                                  <img :src="item" @click="previewImage(item)" class="avatar" />
                                </div>
                              </el-form-item>
                              <el-form-item label="说明:" class="editFItem" prop="illustrate">
                                {{editForma.tjxsm}}
                              </el-form-item>
                            </div>
                          </div>
                          <div class="orderCBox">
                            <div class="orderXTit">验收提交</div>
                            <div class="orderFrom">

                              <el-form-item label="验收结果:" class="orderFItem orderDx tjdxan">
                                {{editForma.statea==1?'通过':'不通过'}}

                              </el-form-item>
                              <el-form-item label="说明:" class="editFItem" prop="illustrate">
                                {{editForma.ys}}
                              </el-form-item>
                              <el-form-item label="验收评价:" class="editFItem tjdxan" prop="">
                                <el-radio-group v-model="editForma.thumb">
                                  <el-radio  v-for="(todo, index) in pjtodos" :label="todo.title">{{todo.title}}</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="dialog-footer">
                            <el-button type="primary"  @click="addordera(1)">保存</el-button>
                            <el-button @click="editShowa = false;editForma=[];fileLista=[]" class="Password_hide">取 消</el-button>
                          </div>
                        </el-form>
                      </el-dialog>
                      <el-dialog :visible.sync="previewVisible" title="图片预览">
                        <img :src="previewImageSrc" class="preview-image" />
                      </el-dialog>
                      <el-dialog
                          title="图片查看"
                          :visible.sync="dialogVisible"
                          width="30%"
                          :before-close="handleClose">
                        <img :src="currentImage" style="width: 100%" />
                      </el-dialog>
                    </el-main>
                </div>
            </div>
        </el-container>
    </el-container>
</template>

<script>
import axios from "axios";

export default {
    // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
    // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
    name: 'endorder',
    data() {
        return {
            asideId: 9,
            value1: '',
            on_orderId: 5,
            app_asideId:9,
            taskFrom: [],
            tableData: [],
          pjtodos: [],
          todos:[],
          onpage:0,
          pagesize:0,
          detailsShow:false,
          listcon: [],
          previewVisible: false,
          previewImageSrc: '',
          editForma: [],
          editShowa:false,
          dialogVisible: false,
          currentImage: '',
        }
    },
    beforeRouteLeave(to, from, next) {
      this.$store.commit('savePageState', {
        pageName: "endorder",
        pageState: {
          taskFrom: this.taskFrom,
          onpage: this.onpage,
          pagesize: this.pagesize
        }
      });
      next();
    },
    // 这里为了测试被切换的组件去哪了
    mounted() {
      this.todos=this.$store.state.tags
      let todos= this.todos
      console.log(this.todos);
      let index =todos.findIndex(note => note.path === "endorder");
      if(index>=0){
        this.activeTabIndex=index
      }else{
        const newNote = {
          title: "完结订单",
          path: 'endorder'
        }
        this.$store.state.tags.push(newNote);
        this.activeTabIndex=this.todos.length - 1
      }
      this.userpath=this.$store.state.userpath
      this.fetchTableData();
      let savedState = this.$store.state.pageState["endorder"];
      if (savedState) {
        this.taskFrom=savedState.taskFrom
        this.pagesize=savedState.pagesize
        this.onpage=savedState.onpage
        this.handleCurrentChange(this.onpage)
      }
    },
    methods: {
      handleImageClick(imageSrc) {
        this.currentImage = imageSrc;
        this.dialogVisible = true;
      },
      handleClose(done) {
        this.dialogVisible = false;
        done();
      },
      addordera(e){
        // this.editForm.filea=this.fileList
        const formData = {
          ...this.editForma // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=checkordera', formData, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.editShowa=false;
                this.handleCurrentChange(this.onpage);
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      checkordera(e){
        const formDataa = {};
        formDataa.id=e
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=order_infoa',formDataa,{
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              console.log(data)
              if(data.status==1){
                this.editShowa=true;
                this.editForma=data.arr;
              }else {
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      handleClick(event) {
        let targetElement = event.target;
        // 检查点击的元素或其父元素是否具有 'clickable-image' 类
        while (targetElement && !targetElement.classList.contains('clickable-image')) {
          targetElement = targetElement.parentElement;
        }
        if (targetElement) {
          let imageSrc = targetElement.src;
          console.log(imageSrc)
          this.previewImage(imageSrc);
        }
      },

      previewImage(src) {
        this.previewImageSrc = src;
        this.previewVisible = true;
      },
      switchTab(index) {
        this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
      },
      removeTodo(index) {
        this.todos.splice(index, 1);
        this.$forceUpdate();
        if(index==this.activeTabIndex){
          this.$router.push(this.todos[index].path);
        }else if(index<this.activeTabIndex){
          this.activeTabIndex=this.activeTabIndex-1
        }
      },
        on_order(e) {
            console.log('e', e)
            this.on_orderId = e
            if (e == 1) {
                this.$router.push('/Publish_task')
            } else if (e == 2) {
                this.$router.push('/tasklist')
            } else if (e == 3) {
                this.$router.push('/order')
            } else if (e == 4) {
                this.$router.push('/consumer')
            }else if (e == 5) {
                this.$router.push('/endorder')
            }
        },
      fetchTableData() {
        console.log(123)
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=3')
            .then(response => {
              this.tableData = response.data.arr;
              this.pagesize = response.data.pagesize;
              this.pjtodos = response.data.todo;
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });

      },
      list(){
        const formDataa = {
          ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=3', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.tableData=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      sizechange(val){
        this.taskFrom.size = val
        this.taskFrom.page = 0
        const formDataa = {
          ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=3', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.tableData=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      handleCurrentChange(val){
        this.taskFrom.page = val
        const formDataa = {
          ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
        };
        axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist&lx=3', formDataa, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为JSON
          }
        })
            .then(response => {
              const data=response.data
              if(data.status==1){
                this.tableData=data.arr
                this.pagesize=data.pagesize
              }else{
                this.$message({
                  type: 'info',
                  message: data.msg
                });
              }
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      },
      detailsShowa(e){
        axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=order_info&id='+e)
            .then(response => {
              this.listcon = response.data.arr;
              console.log(this.listcon.price)
              this.detailsShow = true;
            })
            .catch(error => {
              // 处理错误情况
              console.error("There was an error!", error);
            });
      }
    },
}
</script>

<style>

</style>